import { Text } from '@chakra-ui/layout';
import { Button, Card, Flex, Icon } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import Image from 'next/image';
import { useRef } from 'react';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import LeftIcon from '@/assets/icons/ic-left.svg';
import RightIcon from '@/assets/icons/ic-right.svg';
import Example from '@/assets/images/presentation/gentleman.png';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

import { queryTestimonials } from '@/queries/testimonals';

export const TestimonialsCarousel = () => {
  const swiperRef = useRef<SwiperCore>();
  const { data } = useResources(queryTestimonials());

  const shouldShowArrows = data.length > 1;

  return (
    <Flex maxW="930px" w="full" alignItems="center">
      {shouldShowArrows && (
        <Button
          variant="unstyled"
          leftIcon={<Icon color="black" w="32px" h="32px" as={LeftIcon} />}
          onClick={() => swiperRef.current?.slidePrev()}
        />
      )}
      <Swiper
        loop={true}
        spaceBetween={10}
        slidesPerView={1}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {data.map((m) => (
          <SwiperSlide key={m.id}>
            <Card p={{ base: 4, lg: 12 }}>
              <Flex flexDirection="column" alignItems="center">
                <Text textAlign="center" fontStyle="italic">
                  &quot;{m.text}&quot;
                </Text>
                <Flex mt={4}>
                  <Flex alignSelf="center" alignItems="center">
                    <Image
                      src={m.mediumAuthorImageUrl || Example}
                      alt={m.authorName}
                      width={60}
                      height={60}
                      style={{ borderRadius: '50%', objectFit: 'cover', height: '60px' }}
                    />
                  </Flex>
                  <Flex ml={4} flexDirection="column" alignItems="center">
                    <Text fontFamily="heading" fontWeight="bold" fontSize="lg">
                      {m.authorName}
                    </Text>
                    <Text fontSize="sm" mt={2}>
                      {m.authorInstitution}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      {shouldShowArrows && (
        <Button
          variant="unstyled"
          rightIcon={<Icon color="black" w="32px" h="32px" as={RightIcon} />}
          onClick={() => swiperRef.current?.slideNext()}
        />
      )}
    </Flex>
  );
};
